import React from "react";
import AdminNavbar from "../Navbars/AdminNavbar.js";
import PortalSidebar from "./PortalSidebar";
import { PortalApis } from "../../apis/PortalApis";
import { Oval } from 'react-loader-spinner';
import { FaWallet } from "react-icons/fa";


export default function PortalWallet() {

    const [wallet, setWallet] = React.useState<any>(null);
    const [transactions, setTransactions] = React.useState<any[]>([]);
    const [meta, setMeta] = React.useState<any>(null);
    const [page, setPage] = React.useState<number>(1);
    const [loading, setLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
        PortalApis.getWallet().then((response: any) => {
            if (response?.data?.data) setWallet(response.data.data);
        });
    }, []);

    React.useEffect(() => { loadTransactions(); }, [page]);

    const loadTransactions = () => {
        setLoading(true);
        PortalApis.getWalletTransactions(page).then((response: any) => {
            setLoading(false);
            if (response?.data?.data) {
                setTransactions(response.data.data);
                setMeta(response.data.meta || null);
            }
        }).catch(() => setLoading(false));
    };

    return (
        <>
            <PortalSidebar title="Wallet" />
            <div className="relative md:ml-64 bg-[#FAFAFA]">
                <AdminNavbar title="Wallet" />
                <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

                    {/* Wallet Balance Card */}
                    <div className="lg:pt-5 pt-3">
                        <div className="bg-white rounded-[10px] border border-[#E2E8F0] px-[26px] py-[24px]">
                            <div className="flex items-center gap-3 mb-2">
                                <FaWallet className="text-[#E04343]" size={24} />
                                <h3 className="text-[20px] font-semibold">Wallet Balance</h3>
                            </div>
                            <h1 className="text-[48px] font-[700] text-[#263238]">
                                ₦{(wallet?.balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                            </h1>
                            <p className="text-[13px] text-[#999999] mt-1">
                                Contact your account manager to fund your wallet for API usage.
                            </p>
                        </div>
                    </div>

                    {/* Transactions */}
                    <div className="px-6 mt-6 bg-white pt-[24px] rounded-[10px] pb-10">
                        <div className="flex justify-start">
                            <span className="font-[700]">Transaction History</span>
                        </div>
                        <div className="relative overflow-x-auto mt-6">
                            {loading ? (
                                <div className="flex justify-center py-16">
                                    <Oval visible={true} height="35" width="35" color="#E04343" secondaryColor="#FCBF94" />
                                </div>
                            ) : (
                                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA]">
                                        <tr>
                                            <th scope="col" className="px-2 py-2">S/N</th>
                                            <th scope="col" className="px-2 py-2">Type</th>
                                            <th scope="col" className="px-2 py-2">Amount</th>
                                            <th scope="col" className="px-2 py-2">Balance&nbsp;After</th>
                                            <th scope="col" className="px-2 py-2">Description</th>
                                            <th scope="col" className="px-2 py-2">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transactions.map((tx: any, index: any) => (
                                            <tr key={tx.id || index} className="bg-white">
                                                <td className="px-2 py-2">{((page - 1) * 20) + index + 1}</td>
                                                <td className="px-2 py-2">
                                                    {tx.type === 'credit' ?
                                                        <b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>Credit</b> :
                                                        <b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>Debit</b>
                                                    }
                                                </td>
                                                <td className="px-6 py-4 font-[600]">
                                                    <span className={tx.type === 'credit' ? 'text-green-600' : 'text-red-500'}>
                                                        {tx.type === 'credit' ? '+' : '-'}₦{(tx.amount || 0).toLocaleString()}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4">₦{(tx.balance_after || 0).toLocaleString()}</td>
                                                <td className="px-6 py-4 text-[12px]">{tx.description || '-'}</td>
                                                <td className="px-6 py-4">{tx.created_at ? new Date(tx.created_at).toLocaleDateString() : ''}</td>
                                            </tr>
                                        ))}

                                        {transactions.length === 0 && (
                                            <tr><td colSpan={6} className="text-center py-8 text-[#808080]">No transactions yet.</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Pagination */}
                        {meta && meta.last_page > 1 && (
                            <div className="flex justify-between items-center mt-4">
                                <span className="text-[12px] text-[#808080]">Page {page} of {meta.last_page}</span>
                                <div className="flex gap-2">
                                    <button disabled={page <= 1} onClick={() => setPage(page - 1)}
                                        className="bg-white border border-[#D1D1D1] px-3 py-1 rounded text-[12px] disabled:opacity-30">Previous</button>
                                    <button disabled={page >= meta.last_page} onClick={() => setPage(page + 1)}
                                        className="bg-[#E04343] text-white px-3 py-1 rounded text-[12px] disabled:opacity-30">Next</button>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </>
    );
}